module.exports = __webpack_public_path__ + "img/img_install_02.f0fc3610.png";